import { Center, Paper, type PaperProps } from "@mantine/core";
import type { IconProps } from "@tabler/icons-react";
import type { ComponentType, ReactNode } from "react";
import { axioTokens } from "../../theme";
import { AxioLoader } from "../AxioLoader";
import { EmptyState } from "./EmptyState";
import { ErrorState } from "./ErrorState";
import { ListScrollSentinel } from "./ListScrollSentinel";

interface DataTableShellProps extends PaperProps {
  children: ReactNode;
  loading?: boolean;
  error?: ReactNode;
  onRetry?: () => void;
  hasMore?: boolean;
  loadingMore?: boolean;
  onLoadMore?: () => void;
  empty?: {
    title: string;
    description?: ReactNode;
    icon?: ComponentType<IconProps>;
    action?: ReactNode;
  };
  isEmpty?: boolean;
}

export function DataTableShell({
  children,
  loading,
  error,
  onRetry,
  hasMore,
  loadingMore,
  onLoadMore,
  empty,
  isEmpty,
  ...paperProps
}: DataTableShellProps) {
  return (
    <Paper
      withBorder

      p="var(--axio-unit-0)"
      style={{
        borderColor: axioTokens.border,
        boxShadow: "none",
        overflow: "hidden",
        background: axioTokens.surfaceElevated,
      }}
      {...paperProps}
    >
      {loading ? (
        <Center py="var(--axio-unit-64)">
          <AxioLoader />
        </Center>
      ) : error ? (
        <ErrorState message={error} onRetry={onRetry} />
      ) : isEmpty && empty ? (
        <EmptyState
          icon={empty.icon}
          title={empty.title}
          description={empty.description}
          action={empty.action}
        />
      ) : (
        <>
          <div className="axio-table-wrap">{children}</div>
          <ListScrollSentinel hasMore={hasMore} loadingMore={loadingMore} onLoadMore={onLoadMore} />
        </>
      )}
    </Paper>
  );
}
